import fetch from 'cross-fetch'

const spektrixApiUrl = 'https://tickets.norden.farm/nordenfarm/api/v3'

const fetchOptions = {
  credentials: 'include',
  mode: 'cors',
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
}

// Get current customer details
export const getCustomerDetails = async () => {
  const response = await fetch(`${spektrixApiUrl}/customer`, {
    method: 'GET',
    ...fetchOptions
  })

  if (!response.ok) {
    throw new Error(`Failed to fetch customer details: ${response.status}`)
  }

  return response.json()
}

// Update customer details
export const updateCustomerDetails = async (updates) => {
  const response = await fetch(`${spektrixApiUrl}/customer`, {
    method: 'PATCH',
    body: JSON.stringify(updates),
    ...fetchOptions
  })

  if (!response.ok) {
    const error = await response.json().catch(() => ({}))
    throw new Error(error.message || `Failed to update customer details: ${response.status}`)
  }

  return response.json()
}

// Change customer password
export const changePassword = async (currentPassword, newPassword) => {
  const response = await fetch(`${spektrixApiUrl}/customer/change-password`, {
    method: 'POST',
    body: JSON.stringify({
      oldPassword: currentPassword,
      newPassword: newPassword
    }),
    ...fetchOptions
  })

  if (!response.ok) {
    const error = await response.json().catch(() => ({}))
    throw new Error(error.message || 'Failed to change password')
  }

  // Success - response is not JSON, just return true
  return true
}

// Get customer addresses
export const getCustomerAddresses = async () => {
  const response = await fetch(`${spektrixApiUrl}/customer/addresses`, {
    method: 'GET',
    ...fetchOptions
  })

  if (!response.ok) {
    throw new Error(`Failed to fetch addresses: ${response.status}`)
  }

  return response.json()
}

// Search addresses by postcode
export const searchAddressesByPostcode = async (postcode) => {
  const response = await fetch(`${spektrixApiUrl}/addresses?postcode=${encodeURIComponent(postcode)}`, {
    method: 'GET',
    ...fetchOptions
  })

  if (!response.ok) {
    throw new Error(`Failed to search addresses: ${response.status}`)
  }

  return response.json()
}

// Get full address details by ID
export const getAddressById = async (addressId) => {
  const response = await fetch(`${spektrixApiUrl}/addresses/${addressId}`, {
    method: 'GET',
    ...fetchOptions
  })

  if (!response.ok) {
    throw new Error(`Failed to fetch address details: ${response.status}`)
  }

  return response.json()
}

// Add a new address
export const addCustomerAddress = async (address) => {
  const response = await fetch(`${spektrixApiUrl}/customer/addresses`, {
    method: 'POST',
    body: JSON.stringify(address),
    ...fetchOptions
  })

  if (!response.ok) {
    const error = await response.json().catch(() => ({}))
    throw new Error(error.message || 'Failed to add address')
  }

  return response.json()
}

// Update an existing address
export const updateCustomerAddress = async (addressId, updates) => {
  const response = await fetch(`${spektrixApiUrl}/customer/addresses/${addressId}`, {
    method: 'PATCH',
    body: JSON.stringify(updates),
    ...fetchOptions
  })

  if (!response.ok) {
    const error = await response.json().catch(() => ({}))
    throw new Error(error.message || 'Failed to update address')
  }

  return response.json()
}

// Delete an address
export const deleteCustomerAddress = async (addressId) => {
  const response = await fetch(`${spektrixApiUrl}/customer/addresses/${addressId}`, {
    method: 'DELETE',
    ...fetchOptions
  })

  if (!response.ok) {
    const error = await response.json().catch(() => ({}))
    throw new Error(error.message || 'Failed to delete address')
  }

  return true
}

// Get available statements
export const getStatements = async () => {
  const response = await fetch(`${spektrixApiUrl}/statements`, {
    method: 'GET',
    ...fetchOptions
  })

  if (!response.ok) {
    throw new Error(`Failed to fetch statements: ${response.status}`)
  }

  return response.json()
}

// Get customer agreed statements (communication preferences)
export const getAgreedStatements = async () => {
  const response = await fetch(`${spektrixApiUrl}/customer/agreed-statements`, {
    method: 'GET',
    ...fetchOptions
  })

  if (!response.ok) {
    throw new Error(`Failed to fetch agreed statements: ${response.status}`)
  }

  return response.json()
}

// Add agreed statement (opt-in)
export const addAgreedStatement = async (statementId) => {
  const response = await fetch(`${spektrixApiUrl}/customer/agreed-statements`, {
    method: 'POST',
    body: JSON.stringify([{ id: statementId }]),
    ...fetchOptions
  })

  if (!response.ok) {
    const error = await response.json().catch(() => ({}))
    throw new Error(error.message || 'Failed to opt in to statement')
  }

  return response.json()
}

// Remove agreed statement (opt-out)
export const removeAgreedStatement = async (statementId) => {
  const response = await fetch(`${spektrixApiUrl}/customer/agreed-statements/${statementId}`, {
    method: 'DELETE',
    ...fetchOptions
  })

  if (!response.ok) {
    const error = await response.json().catch(() => ({}))
    throw new Error(error.message || 'Failed to opt out of statement')
  }

  return true
}